import {
  SET_USER,
  GET_USER_FROM_DB,
  GET_USER_FROM_DB_AND_UPDATE_STORE,
  LOGOUT,
  INIT_APP,
  INIT_APP_COMPLETE,
  SET_ACTIVE_VISIT,
  SET_UPCOMING_VISIT,
  SET_CURRENT_VISIT,
  SET_HISTORY,
  SORT_VISITS,
  CHECK_IF_MOBILE,
  SORT_ACTIVE_REPORTS,
  SET_ACTIVE_REPORT,
  GET_ACTIVE_ASSESSMENTS,
  SET_ACTIVE_ASSESSMENTS,
  SET_ACTIVE_ASSESSMENT,
  SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE,
  SET_PROGRESS_BAR_PERCENT,
  SET_SORTED_ASSESSMENTS
} from './action-types';

// Logs the user out from back and front end.
export const logout = meta => ({
  type: LOGOUT,
  meta
});

// Get the latest User document from the DB and set it in the store.
export const getUserFromDBAndUpdateStore = meta => ({
  type: GET_USER_FROM_DB_AND_UPDATE_STORE,
  meta
});

// Get the latest User document from the DB
export const getUserFromDB = meta => ({
  type: GET_USER_FROM_DB,
  meta
});

// Set User in the store
export const setUser = (payload, meta) => ({
  type: SET_USER,
  meta,
  payload
});

export const initApp = () => ({
  type: INIT_APP
});

export const initAppComplete = () => ({
  type: INIT_APP_COMPLETE
});

export const sortVisits = payload => ({
  type: SORT_VISITS,
  payload
});

export const setActiveVisit = (payload, meta) => ({
  type: SET_ACTIVE_VISIT,
  payload,
  meta
});

export const setUpcomingVisit = payload => ({
  type: SET_UPCOMING_VISIT,
  payload
});

export const setCurrentVisit = payload => ({
  type: SET_CURRENT_VISIT,
  payload
});

export const setHistory = payload => ({
  type: SET_HISTORY,
  payload
});

export const setActiveAssessments = (payload, meta) => ({
  type: SET_ACTIVE_ASSESSMENTS,
  payload,
  meta
});

export const setSurveysLastCompletedAt = (payload, meta) => ({
  type: 'SET_SURVEY_LAST_COMPLETED_DATE',
  payload,
  meta
});

export const setSurveysLastUpdatedAt = (payload, meta) => ({
  type: 'SET_SURVEY_LAST_UPDATED_DATE',
  payload,
  meta
});
export const setSurveysLastModifiedOn = (payload, meta) => ({
  type: 'SET_SURVEY_LAST_MODIFIED_DATE',
  payload,
  meta
});

export const setSortedAssessments = (payload, meta) => ({
  type: SET_SORTED_ASSESSMENTS,
  payload,
  meta
});

export const setActiveAssessment = (payload, meta) => ({
  type: SET_ACTIVE_ASSESSMENT,
  payload,
  meta
});

export const getActiveAssessments = (payload, meta) => ({
  type: GET_ACTIVE_ASSESSMENTS,
  payload,
  meta
});

export const setActiveReport = (payload, meta) => ({
  type: SET_ACTIVE_REPORT,
  payload,
  meta
});

export const sortActiveReports = (payload, meta) => ({
  type: SORT_ACTIVE_REPORTS,
  payload,
  meta
});

export const setProgressBarPercent = (payload, meta) => ({
  type: SET_PROGRESS_BAR_PERCENT,
  payload,
  meta
});

export const setUpcomingVisitAssessmentsNotice = (payload, meta) => ({
  type: SET_UPCOMING_VISIT_ASSESSMENTS_NOTICE,
  payload,
  meta
});

export const checkIfMobile = (payload, meta) => ({
  type: CHECK_IF_MOBILE,
  payload,
  meta
});
